<template>
  <div class="certification">
    <van-nav-bar
      title="资质认证"
      left-arrow
      fixed
      placeholder
      @click-left="$router.go(-1)"
    />

    <van-steps
      :active="active"
      active-color="#e21e48"
      style="padding: 10px 50px"
    >
      <van-step>填写个人信息</van-step>
      <van-step>账户验证</van-step>
    </van-steps>

    <div class="main">
      <div class="form">
        <div class="form-item">
          <p class="label">姓名（不可编辑）</p>
          <p class="content">{{ EncryptName(form.realName) }}</p>
        </div>
        <div class="form-item">
          <p class="label">身份证号（不可编辑）</p>
          <p class="content">{{ EncryptCert(form.idNumber) }}</p>
        </div>
        <template v-if="active == 0">
          <div class="form-item">
            <p class="label">身份证号有效期</p>
            <van-checkbox
              v-model="form.idCardLong"
              class="islong"
              checked-color="#ee0a24"
              icon-size="16px"
              >长期</van-checkbox
            >
            <div class="content picker">
              <div v-if="!form.idCardLong" @click="show = true">
                <span v-if="form.idCardVid">{{ form.idCardVid }}</span>
                <span v-else style="color: #909399">请与身份证保持一致</span>
                <i class="el-icon-arrow-right" style="float: right"></i>
              </div>
            </div>
          </div>
          <div class="form-item no-border">
            <p class="label">身份证照片</p>
            <div class="content">
              <div
                class="one-uploader"
                @click="
                  face = 'idCardFront';
                  showUploader = true;
                "
              >
                <el-image
                  class="img"
                  v-if="form.idCardFront"
                  :src="form.idCardFront"
                  fit="cover"
                ></el-image>
                <el-image
                  v-else
                  :src="require('@/assets/images/simulation/idCard1.png')"
                  fit="cover"
                ></el-image>
                <p>身份证人像面</p>
              </div>
              <div
                class="one-uploader"
                @click="
                  face = 'idCardBack';
                  showUploader = true;
                "
              >
                <el-image
                  class="img"
                  v-if="form.idCardBack"
                  :src="form.idCardBack"
                  fit="cover"
                ></el-image>
                <el-image
                  v-else
                  :src="require('@/assets/images/simulation/idCard2.png')"
                  fit="cover"
                ></el-image>

                <p>身份证国徽面</p>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="form-item">
            <p class="label">银行卡号</p>
            <p class="content">
              <van-field
                v-model="form.bankNumber"
                placeholder="请填写与姓名一致的银行卡号"
                style="padding: 0"
              />
            </p>
          </div>
          <div class="form-item">
            <p class="label">银行预留手机号</p>
            <p class="content">
              <van-field
                v-model="form.mobile"
                placeholder="请填写银行预留的手机号"
                style="padding: 0"
                maxlength="11"
              />
            </p>
          </div>
          <div class="form-item">
            <p class="label">验证码</p>
            <p class="content">
              <van-field
                v-model="form.code"
                placeholder="请输入短信验证码"
                style="padding: 0"
                maxlength="4"
              />
              <span class="send-btn" @click="form.code = 'yyds'">发送验证码</span>
            </p>
          </div>
        </template>
      </div>
      <div class="btn" :class="{ disabled }" @click="handleNext">
        {{ active == 0 ? "下一步" : "提交" }}
      </div>
    </div>

    <van-popup
      v-model="show"
      position="bottom"
      round
      :style="{ height: '50%' }"
    >
      <van-datetime-picker
        type="date"
        title="选择日期"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="handleDate"
        @cancel="show = false"
      />
    </van-popup>

    <van-popup
      v-model="showUploader"
      position="bottom"
      round
      :style="{ height: '68%' }"
    >
      <div style="padding: 10px">
        <p class="p-title">上传照片示例</p>
        <el-image
          :src="require('@/assets/images/simulation/frontIdCardImg.png')"
          fit="cover"
        ></el-image>
        <p class="p-tips">
          证件文字能清晰辨认，勿遮挡或模糊，参考示例照片拍摄；格式jpg、png、jpeg，小于5M。
        </p>
        <el-upload
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="upload"
        >
          <div class="btn">上传照片</div>
        </el-upload>
      </div>
    </van-popup>
  </div>
</template>

<script>
import "vant/lib/index.css";
import {
  NavBar,
  Step,
  Steps,
  Checkbox,
  Popup,
  DatetimePicker,
  Dialog,
  Field,
} from "vant";
import { formatDate } from "@/utils/index";
import upload from "@/utils/uploadMethod";
export default {
  props: {
    form: Object,
  },
  components: {
    [NavBar.name]: NavBar,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Field.name]: Field,
  },
  data() {
    return {
      active: 0,
      show: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2500, 12, 31),
      currentDate: new Date(),
      face: "",
      showUploader: false,
    };
  },
  watch: {
    "form.idCardLong"(val) {
      if (val) this.form.idCardVid = "长期";
      else this.form.idCardVid = "";
    },
  },
  computed: {
    disabled() {
      if (this.active == 0)
        return (
          (!this.form.idCardVid && !this.form.idCardLong) ||
          !this.form.idCardFront ||
          !this.form.idCardBack
        );
      else return !this.form.bankNumber || !this.form.mobile || !this.form.code;
    },
  },
  methods: {
    EncryptName(name) {
      let newStr;
      if (name.length === 2) {
        newStr = "*" + name.substr(-1, 1);
      } else if (name.length > 2) {
        let char = "";
        for (let i = 0, len = name.length - 2; i < len; i++) {
          char += "*";
        }
        newStr = name.substr(0, 1) + char + name.substr(-1, 1);
      } else {
        newStr = name;
      }

      return newStr;
    },
    EncryptCert(cert) {
      return cert.replace(/^(.{3})(?:\d+)(.{4})$/, "$1*********$2");
    },
    formatter(date) {
      return formatDate(date, "YYYY-MM-DD");
    },
    handleDate(val) {
      this.form.idCardVid = this.formatter(val);
      this.show = false;
    },
    async upload(file) {
      const fileUrl = await upload(file);
      this.form[this.face] = fileUrl;
      this.showUploader = false;
    },
    handleNext() {
      if (!this.disabled) {
        if (this.active == 0) {
          Dialog.confirm({
            message: `将以${this.EncryptName(
              this.form.realName
            )} 身份认证为巨量百应平台及精选联盟平台账号的所有人，并就账号下的全部行为承担相应的法律责任。`,
            messageAlign: "left",
            width: "280px",
            className: "confirm-dialog",
            confirmButtonColor: "#000",
            cancelButtonText: "我再想想",
            cancelButtonColor: "#606266",
            getContainer: () => {
              return document.querySelector(".certification");
            },
          })
            .then(() => {
              this.active++;
            })
            .catch(() => {
              // on cancel
            });
        } else {
          this.$router.replace("/simulation/douyinchuchuang/success");
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.certification {
  .main {
    position: relative;
    padding: 10px;
    margin-top: 10px;
    height: calc(100vh - 114px - 10px);
    background-color: #fff;
    .form {
      .form-item {
        position: relative;
        margin-bottom: 15px;
        border-bottom: solid 1px #e4e7ed;
        &.no-border {
          border: none;
        }
        .label {
          color: #909399;
        }
        .islong {
          position: absolute;
          top: 0;
          right: 0;
        }
        .content {
          padding: 10px 0;
          &.picker {
            cursor: pointer;
          }
        }
        .one-uploader {
          display: inline-block;
          width: 45%;
          vertical-align: top;
          cursor: pointer;
          &:last-child {
            margin-left: 30px;
          }
          .img {
            width: 100%;
            height: 94px;
          }
          p {
            margin-top: 5px;
            font-size: 12px;
            color: #909399;
          }
        }
        .send-btn {
          position: absolute;
          right: 0;
          top: 30px;
          color: #000;
          cursor: pointer;
        }
      }
    }
  }
  .btn {
    position: absolute;
    bottom: 10px;
    width: 94%;
    padding: 10px 0;
    text-align: center;
    color: #fff;
    background-color: #e21e48;
    border-radius: 3px;
    user-select: none;
    cursor: pointer;
    &.disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
  .p-title {
    padding: 10px 0;
    text-align: center;
  }
  .p-tips {
    margin-top: 10px;
    color: #909399;
  }
  ::v-deep .confirm-dialog {
    border-radius: 0;
  }
}
</style>